<template>
  <div>
    <v-card-text>
      <h4 class="subheading">{{ $t('purchase.service.request') }}</h4>
      <purchase-message
        :purchase="purchase"
        :message="service.request">
      </purchase-message>

      <template v-if="isInProgress">
        <h4 class="subheading">{{ $t('purchase.service.responseForm') }}</h4>
        <purchase-message-form :purchase="purchase"></purchase-message-form>
      </template>
      <template v-if="isFinished">
        <h4 class="subheading">{{ $t('purchase.service.response') }}</h4>
        <purchase-message
          v-if="service.answer"
          :purchase="purchase"
          :message="service.answer">
        </purchase-message>
      </template>
    </v-card-text>
    <v-card-row actions>
      <purchase-refund
        confirmation
        :purchase="purchase">
      </purchase-refund>
      <v-btn
        v-if="isPending"
        class="ml-3"
        @click.native.stop="accept({ id: purchase.id })"
        primary light
        :loading="loading">
        {{ $t('purchase.service.accept') }}
      </v-btn>
    </v-card-row>
  </div>
</template>

<script>
  import purchase from '@/mixins/purchase'
  import PurchaseMessage from './Message.vue'
  import PurchaseRefund from './Refund.vue'
  import PurchaseMessageForm from './MessageForm.vue'
  export default {
    components: {
      PurchaseMessage,
      PurchaseRefund,
      PurchaseMessageForm
    },
    mixins: [purchase]
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Service.vue